<div class="w-full bg-white border-box radius-10 mb-20" [style.border]="isValidated ? '2px solid #28a745' : 'none'"
  style="border-radius: 10px;" id="contact-verif">
  <div class="p-20 flex content-between" style="border-bottom: solid 1px #F0F5FF;">
    <div class="flex gap-10 align-items-center">
      <div>
        <div class="flex gap-10 align-items-center mb-5">
          <img *ngIf="!isValidated" src="assets/square-icon.svg" alt="">
          <img *ngIf="isValidated" src="assets/valid-square-icon.svg" alt="" width="40px">
          <div>
            <p class="no-margin light-blue bold">1. Déscellement du scrutin à blanc</p>
            <p class="no-margin dark-gray text-sm">Suivi de la saisie des clefs de déscellement par les membres du bureau.</p>
          </div>
        </div>
      </div>
      <app-tag [isValidated]="isValidated"></app-tag>
    </div>

  </div>


  <div *ngIf="isExpanded" id="information-grid" class="p-20">

    <div *ngFor="let assessor of assessors; let i = index"
      class="bg-pastel-blue p-10 mb-10 radius-10 flex content-between align-items-center">
      <ng-container *ngIf="{ pending: hasUnsealed(assessor) && !isValidated } as state">
        <div>
          <p class="dark-blue bold no-margin">{{assessor.name}}</p>
          <p class="light-blue text-sm no-margin">{{assessor.email}}</p>
        </div>

        <div class="flex gap-10 align-items-center">
          <v8te-active-button *ngIf="state.pending" [buttonText]="'Renvoyer email'" [boxShadow]="'0px 3px 6px #00000008'"
            [primaryColor]="'#FFFFFF'" [textPrimaryColor]="'#2B2D67'" [iconPosition]="'left'" [border]="'none'"
            [icon]="'assets/mail-dark-blue.svg'" [iconAlt]="'mail icon'" (click)="relaunchAssessorEvent.emit(assessor.email)"
            [height]="'40px'" [minWidth]="'180px'" [width]="'180px'"></v8te-active-button>
          <v8te-active-button *ngIf="state.pending" [buttonText]="'Modifier email'" [boxShadow]="'0px 3px 6px #00000008'"
            [primaryColor]="'#FFFFFF'" [textPrimaryColor]="'#2B2D67'" [iconPosition]="'left'" [border]="'none'"
            [icon]="'assets/pen-icon.svg'" [iconAlt]="'pen icon'" (click)="updateAssessorEvent.emit(assessor.email)" [height]="'40px'"
            [minWidth]="'180px'" [width]="'180px'"></v8te-active-button>
          <app-custom-tag [isValidated]="true"
            [text]="state.pending ? 'En attente' : 'Validé'"
            [backgroundColor]="state.pending ? '#FFFBEC' : '#D2F8DD'"
            [textColor]="state.pending ? '#F56D24' : '#166534'"
            [icon]="state.pending ? 'assets/clock-orange-icon.svg' : 'assets/valid-green-icon.svg'">
          </app-custom-tag>
        </div>
      </ng-container>
    </div>

    <div class="p-10 mb-10 radius-10" style="display: grid; grid-template-columns: auto 1fr auto; gap: 20px; align-items: center;">
      <p class="dark-blue bold no-margin" style="width: fit-content;">Clefs validées</p>
      <!-- <p>{{((assessors.length - unsealedAssessors.length) / assessors.length) * 100}}</p> -->
      <progress *ngIf="!isValidated" max="100" value="{{((assessors.length - unsealedAssessors.length) / assessors.length) * 100}}" style="width: 100%;"></progress>
      <progress *ngIf="isValidated" max="100" value="100" style="width: 100%;"></progress>
      <p *ngIf="!isValidated" class="dark-blue bold no-margin" style="width: fit-content;">{{assessors.length - unsealedAssessors.length}}/{{assessors.length}}</p>
    </div>

    <div class="w-full bg-pastel-blue p-20 radius-10 border-box">
      <p class="dark-blue bold no-margin">Seuil requis pour ouverture : 2</p>
      <p class="dark-blue no-margin">Calcul (total / 2) + 1 = (3 / 2) + 1 = 2</p>
    </div>

  </div>
</div>
